/*******************************************************************
* PAGE        : HeaderComponent
* REMARKS     : Comman Header Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 12-06-2026
********************************************************************/

import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../store/NotificationContext';
import { Images } from '../../utils/Images';
import ProfileComponent from '../ProfileComponent/ProfileComponent';
import './HeaderComponent.css';
import { useState } from 'react';
import LoaderComponent from '../LoaderComponent/LoaderComponent';

/**
 * HeaderComponent
 * -----------------
 * This component represents the header section of the application, displaying:
 * - Notification icon with count (if any notifications exist)
 * It also navigates to the notification page when clicked.
 */
const HeaderComponent = ({ sidebarIsOpen, isMobile }) => {

    // Navigation hook for route changes
    const navigate = useNavigate();

    // Retrieve the notification count from context
    const { unreadCount } = useNotification();

    const [loading, setLoading] = useState(false);

    const handleLoader = () => {
        setLoading(true);
    }

    return (loading
        ? <LoaderComponent />
        : <div className="header-container">
            <header className="header-subcontainer">
                {/* User Info Display: Greeting message with user's name */}
                {/* <div style={{ width: sidebarIsOpen ? '12%' : "10%" }}>
                    {(!sidebarIsOpen && !isMobile) && <img className="header-company-logo" src={Images.companylogo} alt="Logo" onClick={() => navigate('/dashboard')} />}
                </div> */}

                {/* <div className="header-profile-name">
                    Hello {profile.UserName}
                </div> */}

                {/* Notification Icon: Redirect to notifications page on click */}
                <div className="header-notification">
                    <div className="notification-icon-wrapper" onClick={() => navigate("/notification")}>
                        <img src={Images.notificationIcon} alt="Notifications" className='header-notification-icon' />
                        {/* Show notification count if greater than 0 */}
                        {unreadCount > 0 && (
                            <span className="header-notification-badge">
                                {unreadCount > 99 ? "99+" : unreadCount}
                            </span>
                        )}
                    </div>
                    <ProfileComponent isLoading={handleLoader.bind(this)} />

                </div>
            </header>
        </div>
    );
};

export default HeaderComponent;
